import React, { useState } from 'react';
import './App.scss';
import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import 'bootstrap/dist/css/bootstrap.min.css';
import 'react-bootstrap-typeahead/css/Typeahead.css';
import { FileProvider } from './providers/file.provider';
import { ProviderContext } from './providers/providers.provider';
import ResultPage from './pages/result.page';
import StartRoomPage from './pages/start-room.page';
import { RoomStatus } from './models/report.model';
import { Language } from './enum/language.enum';
import { JobQuestionModel } from './models/questions.model';
import ChooseLanguageWrapper from './components/choose-language-wrapper';
import { LanguageProvider } from './providers/language.provider';
import InterviewRoomPage from './pages/interview-room.page';
import NotFoundPage from './pages/not-found.page';
import PublicInterviewPage from './pages/public-interview.page';
import LandingPage from './pages/landing.page';
import CreatePublicPage from './pages/create-public.page';
import EnglishInterviewLoadingResult from './components/english-interview-loading-result/english-interview-loading-result';
import DemoPage from './pages/demo.page';

// Component to handle conditional landing page access
const ConditionalLandingPage = () => {
  const location = useLocation();
  
  // Check if URL includes "interview-ai-x10"
  if (location.pathname === '/' && window.location.href.includes('interview-ai-admin')) {
    return <NotFoundPage />;
  }
  
  return <LandingPage />;
};
if (process.env.NODE_ENV === "production") {
  console.log = () => {};
  console.debug = () => {};
  console.info = () => {};
  console.warn = () => {};
  console.error = () => {};
}
function App() {
  const [roomModelContext, setRoomModel] = useState<JobQuestionModel>();
  const [roomCheck, setRoomCheck] = useState<RoomStatus>({
    check_camera: false,
    check_mic: false
  });
  const [language, setLanguage] = useState(Language.English);
  return (

    <div className="App">
      {/* <div className='bg-template-gradient-1'></div>
      <div className='bg-template-gradient-1-2'></div>
      <div className='bg-template-gradient-2'></div>
      <div className='bg-template-gradient-2-1'></div> */}
      <LanguageProvider>
        <ProviderContext.Provider
          value={{
            roomModelContext, setRoomModel,
            roomCheck, setRoomCheck,
            language, setLanguage
          }}
        >

          <FileProvider>
            <BrowserRouter>
              <Routes>
              <Route path="/" element={<ConditionalLandingPage />} />
                <Route path="/demo" element={<DemoPage />} />
                <Route path="/:id/:candidate_id/verify" element={<StartRoomPage />} />
                <Route path="/:company_id/job-public/:job_question_id" element={<CreatePublicPage />} />
                <Route path="/public/verify/:company_id/:job_question_id/:candidate_id" element={<PublicInterviewPage />} />
                <Route path="/:id/:candidate_id" element={<ChooseLanguageWrapper />} />
                <Route path="/:id/:candidate_id/:email/:report_id/result" element={<ResultPage />} />
                <Route path="/:id/:candidate_id/:email/interview-room" element={<InterviewRoomPage />} />
                <Route path="/loading-english" element={<EnglishInterviewLoadingResult />} />
                <Route path="*" element={<NotFoundPage />} />
              </Routes>
            </BrowserRouter>
          </FileProvider>

        </ProviderContext.Provider>
      </LanguageProvider>
    </div>

  );
}

export default App;
